import { useApiFetch } from '@/composables/useApiFetch'

const api = useApiFetch()

export async function fetcher<T>(url: string, options?: RequestInit): Promise<T> {
  const res = await api.apiFetch(url, options)
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(text || `HTTP ${res.status}`)
  }
  const contentType = res.headers.get('content-type') || ''
  if (contentType.toLowerCase().includes('application/json')) {
    return (await res.json()) as T
  }
  return undefined as unknown as T
}
